import { ooId } from 'data/mock-data';

const mock = () => ({
  data: { reviseOoId: ooId },
});

export default mock;
